// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__n4SWD","title":"InfoRow_title__ChTr8"};